module.exports = __webpack_public_path__ + "static/media/munin-sad.ce86842c.svg";